import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dialog-base',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './dialog-base.component.html',
  styleUrls: ['./dialog-base.component.scss']
})

export class DialogBaseComponent implements OnInit {

  @Input() titleModal:string = '';

  @Input() textCancel:string = '';
  @Output() eventCancel = new EventEmitter<any>();

  @Input() textSubmit:string = '';
  @Output() eventSubmit = new EventEmitter<any>();
  

  ngOnInit(): void {
  }

  cancelEvent(): void {
    this.eventCancel.emit();
  }

  submitEvent(): void {
    this.eventSubmit.emit();
  }

}